<template>
  <div>

    <p class="tab-hint">
      O white label define a marca que os usuários desta conta enxergam: logo, domínio e cores.
    </p>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="account-partner">Conta parceira</label>
          <select v-model="account.account_id" id="account-partner"
                  class="form-control" :disabled="!partners">
            <option :value="null">Sem parceira, marca padrão Brobot</option>
            <option v-for="partner in partners" :key="partner.id" :value="partner.id">
              {{ partner.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <p v-if="!partners" class="empty">Carregando contas parceiras…</p>

    <template v-else-if="partner">
      <h4 class="section-title">Marca herdada</h4>

      <div class="brand">
        <div class="brand-logo">
          <img v-if="partner.logo_url" :src="partner.logo_url" :alt="partner.name">
          <image-icon v-else size="2x" class="no-logo"/>
        </div>

        <div class="brand-info">
          <span class="brand-name">{{ partner.name }}</span>
          <span class="brand-domain">{{ partner.domain || 'sem domínio configurado' }}</span>

          <div v-if="colors.length" class="swatches">
            <span v-for="color in colors" :key="color.key" class="swatch" :title="`${color.key}: ${color.value}`">
              <span class="swatch-chip" :style="{ background: color.value }"/>
              <span class="swatch-value">{{ color.value }}</span>
            </span>
          </div>
          <span v-else class="brand-domain">sem cores definidas no estilo</span>
        </div>

        <div class="brand-action">
          <button @click="editPartner" :disabled="hasChanges" class="btn btn-outline">
            Editar conta parceira
          </button>

          <span v-if="hasChanges" class="brand-blocked">
            Salve as alterações para editar a conta parceira.
          </span>
        </div>
      </div>
    </template>

    <div v-else class="no-partner">
      Esta conta não pertence a nenhuma parceira: os usuários enxergam a marca padrão Brobot.
    </div>

  </div>
</template>

<script>
  import { ImageIcon } from 'vue-feather-icons'

  const COLOR_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i

  export default {
    components: { ImageIcon },
    computed: {
      colors() {
        const style = this.partner && this.partner.style

        if (!style || typeof style !== 'object')
          return []

        return Object.entries(style)
          .filter(([, value]) => typeof value === 'string' && COLOR_PATTERN.test(value))
          .map(([key, value]) => ({ key: key, value: value }))
      },
      partner() {
        if (!this.account.account_id || !this.partners)
          return null

        return this.partners.find(partner => partner.id === this.account.account_id) || null
      }
    },
    methods: {
      editPartner() {
        this.$router.push(`/admin/partner_accounts/${this.partner.id}`)
      }
    },
    name: 'TabPartner',
    props: {
      account: { required: true, type: Object },
      hasChanges: { default: false, type: Boolean },
      partners: { default: null, type: Array }
    }
  }
</script>

<style scoped>
  .tab-hint {
    margin-bottom: 24px;
    font-size: 13px;
    color: var(--secondary-text-color);
  }

  .section-title {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
    color: var(--primary-text-color);
  }

  .empty {
    font-size: 13px;
    color: var(--secondary-text-color);
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 20px;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    background: var(--card-bg);
  }

  .brand-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 56px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background: var(--white-bg);
  }

  .brand-logo img {
    max-width: 88px;
    max-height: 48px;
  }

  .no-logo {
    color: var(--icon-color);
  }

  .brand-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2px;
  }

  .brand-name {
    font-size: 15px;
    font-weight: 600;
    color: var(--primary-text-color);
  }

  .brand-domain {
    font-size: 13px;
    color: var(--secondary-text-color);
  }

  .swatches {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 6px;
  }

  .swatch {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .swatch-chip {
    width: 16px;
    height: 16px;
    border: 1px solid var(--border-color);
    border-radius: 3px;
  }

  .swatch-value {
    font-family: monospace;
    font-size: 12px;
    color: var(--secondary-text-color);
  }

  .brand-action {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
  }

  .brand-blocked {
    max-width: 180px;
    font-size: 12px;
    text-align: right;
    color: var(--secondary-text-color);
  }

  .no-partner {
    padding: 16px 20px;
    border: 1px dashed var(--border-color);
    border-radius: 5px;
    font-size: 13px;
    color: var(--secondary-text-color);
  }
</style>
